import React, { useMemo } from 'react';
import DoorScreen from './DoorScreen';
import EmptyState from '../EmptyState';
import { createDoorApi, staffCredentials } from '../../services/DoorApiClient';

interface GuestCheckInProps {
  eventId?: string | null;
}

/** Guest check-in for the event chosen in the event-day header: the door screen on the per-event routes. */
const GuestCheckIn: React.FC<GuestCheckInProps> = ({ eventId }) => {
  const api = useMemo(() => createDoorApi(staffCredentials), []);
  if (!eventId) {
    return (
      <EmptyState
        icon="calendar"
        title="Choose an event"
        description="Check-in is per event. Pick the event you are running at the top of the page."
      />
    );
  }
  return <DoorScreen api={api} eventId={eventId} credentials={staffCredentials} />;
};

export default GuestCheckIn;
